import { createUtilityClasses } from './createUtilityClasses';

export const classes = createUtilityClasses(['p', 'pt', 'pb', 'pr', 'pl']);
